module.exports = __webpack_public_path__ + "img/Icon_Spin.f1ec1139.png";